import { render, staticRenderFns } from "./chat_detail.vue?vue&type=template&id=2e04d072&scoped=true&"
import script from "./chat_detail.vue?vue&type=script&lang=js&"
export * from "./chat_detail.vue?vue&type=script&lang=js&"
import style0 from "./chat_detail.vue?vue&type=style&index=0&id=2e04d072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e04d072",
  null
  
)

export default component.exports